import { SpotlightTarget } from "../common";
import { IntroTransition } from "../common/intro-transition";
import { FIRST_ISSUE_ID } from "../constants/ui";
import {
    getAssetForEpicLink,
    getAssetOptionsForAssignee,
    getAssetOptionsForIssueType,
    getAssetOptionsForPriority
} from "../helpers";
import { useMessages } from "../state";

import { cardStyles } from "./card.styles";

export const Card = ({
    summary,
    epicName,
    issueType,
    priority,
    assignee,
    id,
    role
}: cardProps) => {
    const [messages] = useMessages();
    const epicLinkElement = getAssetForEpicLink(epicName);
    const issueTypeElement = getAssetOptionsForIssueType(
        issueType,
        messages,
        true
    );

    const priorityElement = getAssetOptionsForPriority(
        priority,
        messages,
        true
    );
    const assigneeElement = getAssetOptionsForAssignee(
        assignee,
        messages,
        true
    );

    const card = () => {
        return (
            <div
                css={cardStyles}
                // FIXME: Remove duplicated id `testid`
                id="testid"
                aria-describedby={id}
                role={role}
            >
                <div className="label-container" id={id}>
                    {summary}
                </div>
                <div className="epic-link-row">{epicLinkElement}</div>
                <div className="type-priority-assignee-row">
                    <div className="issue-type-container">
                        {issueTypeElement}
                        {/* Hide text from screen readers since icon label contains relevant information */}
                        <div className="issue-text" aria-hidden>
                            {issueType}
                        </div>
                    </div>
                    <div className="priority-assignee-container">
                        <div>{priorityElement}</div>
                        <div>{assigneeElement}</div>
                    </div>
                </div>
            </div>
        );
    };

    // Conditionally render card wrapped in Transition and Spotlight components if we need to pulse it
    return id === FIRST_ISSUE_ID ? (
        <IntroTransition
            initialCSS="
              position: relative;
              top: 100px;
              opacity: 0.0;
            "
            transitionCSS="
              transition: all 1.0s ease-in-out;
            "
            finalCSS="
              top: 0px;
              opacity: 1.0;
            "
        >
            <SpotlightTarget name={id} pulseSize={20} speed={"slow"}>
                {card()}
            </SpotlightTarget>
        </IntroTransition>
    ) : (
        card()
    );
};

export type cardProps = {
    summary: string;
    epicName: string;
    issueType: string;
    priority: string;
    assignee: string;
} & React.HTMLAttributes<HTMLDivElement>;
